export default "__VITE_ASSET__a30060e3__"